<template>
  <div class="main-body">
    <div class="header">入住评估分类</div>
    <div class="out">

      <div class="search2">

        <el-button type="primary" size="mini" @click.native="toggleModalAdd">添加</el-button>

        <div style="float:right">

          <el-select v-model="institutionCode" placeholder="请选择机构">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-button style="margin-left:10px;" size="mini" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th" border >

        <el-table-column prop="name" label="名称"></el-table-column>

        <el-table-column prop="sumGroup" label="组数"></el-table-column>

        <el-table-column prop="sumScore" label="总分"></el-table-column>

        <el-table-column prop="calculationType" :formatter="getType" label="是否为分数"></el-table-column>

        <el-table-column prop="Status" :formatter="statusTitle" label="状态"></el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

    <el-dialog title='评估分类添加' :visible.sync="batchDialog" class="dialog" width='400px' center top='30vh' :close-on-click-modal='false'>

      <el-form>

        <el-form-item label="机构" required style="width:100%">
          <el-select v-model="institutionCodeAdd" placeholder="请选择机构" style="width: 100%">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="评估分类名称" required style="width:100%">
          <el-input v-model="nameAdd" placeholder="请输入评估分类名称"></el-input>
        </el-form-item>

        <el-form-item label="计算类型是否为分数" required style="width:100%">
          <el-select v-model="calculationTypeAdd" placeholder="请选择计算类型是否为分数" style="width:100%" >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="2"></el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialog=false">取 消</el-button>
        <el-button type="primary"  @click="addSub">提交</el-button>
      </div>

    </el-dialog>

    <el-dialog title='评估分类修改' :visible.sync="batchDialogEdit" class="dialog" width='400px' center top='30vh' :close-on-click-modal='false'>
      <el-form>
        <el-form-item label="评估分类名称" required style="width:100%">
          <el-input v-model="nameEdit" placeholder="请输入评估分类名称"></el-input>
        </el-form-item>
        <el-form-item label="计算类型是否为分数" required style="width:100%">
          <el-select v-model="calculationTypeEdit" placeholder="请选择计算类型是否为分数" style="width:100%" >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="评估分类状态" required style="width:100%">
          <el-select v-model="statusEdit" placeholder="选择评估分类状态" style="width:100%">
            <el-option label="正常" :value="1"></el-option>
            <el-option label="禁用" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="机构" required style="width:100%">
          <el-select v-model="institutionCodeEdit" placeholder="请选择机构" style="width: 100%">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialogEdit=false">取 消</el-button>
        <el-button type="primary"  @click="editSub">提交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Role",
  data(){
    return{
      loading:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      batchDialog:false,
      batchDialogEdit:false,

      nameAdd:'',
      calculationTypeAdd:'',
      institutionCodeAdd:'',

      nameEdit:'',
      calculationTypeEdit:'',
      institutionCodeEdit:'',
      statusEdit:'',

      statusValue:[{
        val:-1,
        name:'全部'
      },{
        val:1,
        name:'正常'
      },{
        val:2,
        name:'禁用'
      }],

      arr_ins:[],
      institutionCode: '',


    }
  },
  created(){
    this.getIns();

    this.th = this.$store.state.tableHeight;
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:2,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },





    toggleModalAdd:function(){
      this.nameAdd='';
      this.calculationTypeAdd='';
      this.batchDialog =true;
    },
    addSub(){

      if(this.institutionCodeAdd==''){
        this.$message({type: 'info', message: '选择机构'});
        return;
      }
      if(this.nameAdd==''){
        this.$message({type: 'info', message: '输入分类名称'});
        return;
      }
      if(this.calculationTypeAdd==''){
        this.$message({type: 'info', message: '选择计分类型'});
        return;
      }


      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CheckinAssessClass/GovAdd",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name:this.nameAdd,
          calculationType:this.calculationTypeAdd,
          institutionCode:this.institutionCodeAdd,
        }
      }).then( (response)=> {
        if(response.data.error == 0){
          this.batchDialog=false
          this.getList();
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


    handleEdit(index,row) {
      this.checkinAssessClassCode=row.checkinAssessClassCode;
      this.nameEdit=row.name;
      this.statusEdit=row.status;
      this.calculationTypeEdit=row.calculationType;
      this.institutionCodeEdit = row.institutionCode;
      this.batchDialogEdit=true;
    },
    editSub(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CheckinAssessClass/GovEdit",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          checkinAssessClassCode:this.checkinAssessClassCode,
          name:this.nameEdit,
          status:this.statusEdit,
          calculationType:this.calculationTypeEdit,
          institutionCode:this.institutionCodeEdit,
        }
      }).then( (response)=> {
        if(response.data.error == 0){
          this.batchDialogEdit=false
          this.getList();
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CheckinAssessClass/GovPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          institutionCode:this.institutionCode,
        }
      }).then( (response)=> {

        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


    getType(a,b,data){
      if(data==1){
        return '是'
      }
      return '否'
    },


    statusTitle(row){
      const statusValue=this.statusValue
      for(var i in statusValue){
        if(statusValue[i].val==row.status){
          return statusValue[i].name
        }
      }
    },


  }
}
</script>

<style lang='scss' scoped>

</style>
